__webpack_require__.p = "/stock-tracker/";